import Backbone from 'backbone';
import $ from 'jquery';

import CreateSequenceAlignmentsModal from 'analyses/alignment/modals/CreateSequenceAlignmentsModal';
import {BioentityInput, InputType} from 'analyses/alignment/modals/createSequenceAlignmentsModalReducer';
import {Alignment} from 'analyses/Analyses';
import {track} from 'analytics/Analytics';
import {SequenceSummary} from 'constants/SequenceConstants';
import notifications from 'notifications';
import runModal from 'ui-library/runModal';
import ifCreateFromHash from 'util/ifCreateFromHash';

export default class AlignmentView extends Backbone.View<Alignment> {
  static openModalWithIds(sequenceIds: Array<string>): JQueryPromise<SequenceSummary> {
    // This function is currently only used by the folder expanded toolbar.
    track('alignment', 'openModal', {source: 'folder-expanded-toolbar'});
    return (
      $.ajax({
        url: '/1/api/sequences/summaries',
        type: 'GET',
        dataType: 'json',
        traditional: true,
        data: {id: sequenceIds},
      })
        .fail(notifications.notifyError)
        // Just give a plain backbone model with the sequence summary dict, since that's all that
        // the alignment modal needs.
        .done((resp: Array<SequenceSummary>) => {
          this.openModalWithSequences(resp);
        })
    );
  }

  static openModalWithSequences(sequences: Array<SequenceSummary>): void {
    const initialInputs: Array<BioentityInput> = sequences.map((seq) => ({
      type: InputType.BIOENTITY,
      name: seq.name,
      id: seq.id,
      canBeTemplate: seq.permissions.polymerFeaturesEditable ?? false,
      useCurrentVersion: true,
      nucleotideType: seq.nucleotideType,
    }));
    runModal(CreateSequenceAlignmentsModal, {initialInputs});
  }

  render(): this {
    $(document).on('click', '.js-create-alignment', (e) => {
      e.preventDefault();
      track('alignment', 'openModal', {source: 'global-create'});
      AlignmentView.openModalWithSequences([]);
    });

    ifCreateFromHash('#create/alignment', (hash: string) => {
      if (hash.indexOf('#create/alignment?') === 0) {
        const sequenceIds = hash.slice('#create/alignment?'.length).split('&');
        AlignmentView.openModalWithIds(sequenceIds);
      } else {
        AlignmentView.openModalWithSequences([]);
      }
    });
    return this;
  }
}
